import { store } from '../../store'

export async function _initializeData() {
  const state = store.getState()
  const { mainState } = state

  await Promise.all([]).then(([]) => {})
}
